<template>
	<v-toolbar-items v-if="show" cols="6" md="6" id="menu-nav">
		<div id="menu-nav-desktop" v-if="currentRoute.name != 'Login'">
			<router-link
				v-if="showEspacePersonnel"
				:to="{ name: 'Topic Dashboard Index', params: { topicSlug: topicSlug, formationId: formationId } }"
				class="pl-3 pr-3 navBarLink"
			>
				<span>Espace Personnel</span>
			</router-link>
			<router-link
				v-if="topicSlug && showAssistantTab(topicSlug) && formationId"
				:to="{ name: 'TopicAssistant', params: { topicSlug: topicSlug, formationId: formationId } }"
				class="pl-3 pr-3 navBarLink"
				:class="{ purpleColor: currentRoute.name == 'TopicAssistant' }"
			>
				<span>Assistant</span>
			</router-link>
			<router-link
				:to="{ name: 'TestHomePage', query: { topicSlug: this.topicSlug, formationId: this.formationId } }"
				class="pl-3 pr-8 navBarLink"
				:class="{ purpleColor: currentRoute.name == 'TestHomePage' }"
			>
				<TestHomePageNavItem />
			</router-link>
		</div>
	</v-toolbar-items>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { showNavBar } from '@/utils/navbar.js';
import MixPanel from '@/utils/mixpanel.js';
import TestHomePageNavItem from '@/components/navbar/TestHomePageNavItem.vue';
import { isPastGivenTime } from '@/utils/time.js';

export default {
	name: 'SessionParcoursNavItemsDesktop',
	components: { TestHomePageNavItem },
	props: {
		currentRoute: Object,
		parcoursId: String,
	},
	data: () => {
		return { formation: null };
	},
	computed: {
		...mapGetters('profile', { formationProgress: 'formationProgress' }),
		show() {
			return showNavBar(this.currentRoute.name);
		},
		showEspacePersonnel() {
			if (this.formation != null) {
				return isPastGivenTime(this.formation.begin_date);
			}
			if (this.formationProgress != null && this.formationProgress.formation != null) {
				const { formation } = this.formationProgress;
				return isPastGivenTime(formation.begin_date);
			}
			return true;
		},
		formationId() {
			if (this.currentRoute.query.formationId) return this.currentRoute.query.formationId; // Test home page
			if (this.formationProgress == null) return '';
			return this.formationProgress.formation._id;
		},
		topicSlug() {
			if (this.currentRoute.query.topicSlug) return this.currentRoute.query.topicSlug; // Test home page
			if (this.formationProgress == null) return '';
			return this.formationProgress.config.topic_id.slug;
		},
	},
	methods: {
		...mapActions('formation', ['getFormationData']),
		onDashboardAssistant() {
			MixPanel.trackToAssistant;
		},
		showAssistantTab(topicSlug) {
			const TOPIC_SLUGS_NOT_SHOW_ASSISTANT = ['cyber', 'ia'];
			return !TOPIC_SLUGS_NOT_SHOW_ASSISTANT.includes(topicSlug);
		},
	},
	async mounted() {
		if (this.formationProgress == null && this.currentRoute.query.formationId) {
			// Case Test Home Page
			this.formation = await this.getFormationData({ idFormation: this.currentRoute.query.formationId });
		}
	},
};
</script>

<style scoped lang="scss">
#menu-nav-desktop {
	display: flex;
	align-items: center;
	a {
		&:not(:last-child) {
			border-right: 1px solid #989fa9;
		}
	}

	a {
		color: #989fa9 !important;
	}

	a:hover {
		color: #686bdf !important;
	}

	.navBarLink {
		font-weight: 500;
		letter-spacing: 0.0892857143em;
		text-transform: uppercase;
		font-size: 12px;
		height: 15px;
	}

	.purpleColor {
		color: #686bdf !important;
	}
}
</style>
